const getters = {
  drawerMenuOpen: (state) => {
    return state.drawerMenuOpen
  },
  getSelectedCustomFilters: (state) => {
    return state.selectedCustomFilters
  }
}
export default getters
